import { Link } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import { SUPPORT_EMAIL_ADDRESS } from 'utils/constants';
import styles from './MailtoSupport.module.scss';

export type MailtoSupportProps = {
  children?: React.ReactNode;
  className?: string;
};

const MailtoSupport: React.FC<MailtoSupportProps> = ({
  children = 'Contact us',
  className,
}) => (
  <Link
    className={cn(styles.root, className)}
    variant="inherit"
    href={`mailto:${SUPPORT_EMAIL_ADDRESS}`}
  >
    {children}
  </Link>
);

export default MailtoSupport;
